import React, { useEffect, useState } from 'react';

interface CelebrationAnimationProps {
    onComplete: () => void;
}

interface ConfettiParticle {
    id: number;
    x: number;
    y: number;
    color: string;
    rotation: number;
    velocityX: number;
    velocityY: number;
}

export const CelebrationAnimation: React.FC<CelebrationAnimationProps> = ({ onComplete }) => {
    const [confetti, setConfetti] = useState<ConfettiParticle[]>([]);

    useEffect(() => {
        // Create confetti particles
        const colors = ['#fbbf24', '#10b981', '#3b82f6', '#ef4444', '#8b5cf6', '#f97316'];
        const particles: ConfettiParticle[] = [];
        
        for (let i = 0; i < 50; i++) {
            particles.push({
                id: i,
                x: Math.random() * window.innerWidth,
                y: -10,
                color: colors[Math.floor(Math.random() * colors.length)],
                rotation: Math.random() * 360,
                velocityX: (Math.random() - 0.5) * 4,
                velocityY: Math.random() * 3 + 2
            });
        }
        
        setConfetti(particles);
        
        // Don't auto-complete - let App.tsx control timing
    }, []);

    useEffect(() => {
        const animate = () => {
            setConfetti(prev => prev.map(particle => ({
                ...particle,
                x: particle.x + particle.velocityX,
                y: particle.y + particle.velocityY,
                rotation: particle.rotation + 5
            })).filter(particle => particle.y < window.innerHeight + 10));
        };

        const animationInterval = setInterval(animate, 50);
        return () => clearInterval(animationInterval);
    }, []);

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 50,
            pointerEvents: 'none'
        }}>
            {/* Confetti particles */}
            {confetti.map(particle => (
                <div
                    key={particle.id}
                    style={{
                        position: 'absolute',
                        left: particle.x,
                        top: particle.y,
                        width: '10px',
                        height: '10px',
                        backgroundColor: particle.color,
                        transform: `rotate(${particle.rotation}deg)`,
                        borderRadius: '2px',
                        opacity: 0.8
                    }}
                />
            ))}
            
            {/* Main celebration content - clickable */}
            <div 
                onClick={onComplete}
                style={{
                    backgroundColor: 'white',
                    padding: '48px',
                    borderRadius: '24px',
                    textAlign: 'center',
                    animation: 'celebrationBounce 0.5s ease-out',
                    pointerEvents: 'auto',
                    cursor: 'pointer',
                    transition: 'transform 0.2s',
                    border: '2px solid #10b981'
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
            >
                <div style={{ fontSize: '96px', marginBottom: '16px' }}>🎉</div>
                <div style={{ fontSize: '36px', fontWeight: 'bold', color: '#059669', marginBottom: '16px', direction: 'rtl' }}>
                    מעולה!
                </div>
                <div style={{ fontSize: '24px', color: '#374151', direction: 'rtl' }}>
                    השלמת את המילה בהצלחה
                </div>
                <div style={{ fontSize: '18px', color: '#6b7280', marginTop: '8px', direction: 'rtl' }}>
                    👆 לחץ כאן לעבור למילה הבאה
                </div>
            </div>
        </div>
    );
};